import { KeyboardButtonProps } from '@ncr-design-system/keyboard';

export const CustomKeys: { [key: string]: { [key: string]: KeyboardButtonProps } } = {
  keyboardWithEnterButton: {
    '{enter}': {
      buttonName: 'enter',
      pressAction: 'add',
      text: 'Enter',
    },
  },
  keyboardWithClearAndNextButton: {
    '{numpad-1}': {
      buttonName: 'clear',
      pressAction: 'none',
      text: 'C',
    },
    '{enter}': {
      buttonName: 'next',
      pressAction: 'none',
      text: 'Next',
    },
  },
  keyboardWithRegisterButton: {
    '{enter}': {
      buttonName: 'enter',
      pressAction: 'none',
      text: 'Register',
    },
  },
  keyboardWithSearchButton: {
    '{enter}': {
      buttonName: 'enter',
      pressAction: 'none',
      text: 'Search',
    },
  },
  keyboardWithNextButton: {
    '{enter}': {
      buttonName: 'next',
      pressAction: 'none',
      text: 'Next',
    },
  },
};
